<template>
    <v-card>
        <v-card-title>
        <span class="headline">Cargo Port Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newPort">
                <v-text-field :label="labels.port" v-model="portForm.port" :error-messages="errors.collect('port')" data-vv-name="port" :data-vv-as="labels.port" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.port}}</v-subheader>
                <div class="title">{{portForm.port}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="portForm.portDesc" :label="labels.portDesc" :error-messages="errors.collect('portDesc')" v-validate="'required|entry|max:100'" data-vv-name="portDesc" :data-vv-as="labels.portDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'portForm': Object,
    'newPort': Boolean
  },
  data() {
    return {
      labels: {
        port: 'Port Code*',
        portDesc: 'Port Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.portForm.port = undefined
      this.portForm.portDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPort) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.cargo.menu.createPort
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.portForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.cargo.menu.updatePort
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.portForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
